import { render, staticRenderFns } from "./companyVote.vue?vue&type=template&id=e2caffa2&scoped=true&"
import script from "./companyVote.vue?vue&type=script&lang=js&"
export * from "./companyVote.vue?vue&type=script&lang=js&"
import style0 from "./companyVote.vue?vue&type=style&index=0&id=e2caffa2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2caffa2",
  null
  
)

export default component.exports